import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnInit, QueryList, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
import { getLayerKey } from './layer-key.pipe';
var LegendDataComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LegendDataComponent, _super);
    function LegendDataComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.renderPromises = [];
        return _this;
    }
    LegendDataComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ESRI.SymbolUtils];
                    case 1:
                        _a.SymbolUtils = _b.sent();
                        window.addEventListener('symbolChange', function (e) {
                            if (_this.node.data.layerData && _this.node.data.layerData.layer && _this.node.data.layerData.layer.id === e.detail) {
                                _this.renderSymbols();
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendDataComponent.prototype.renderSymbols = function () {
        if (this.uniqueValueSymbolsRef.toArray().length) {
            this.addRenderToClassBreak(this.uniqueValueSymbolsRef.toArray());
        }
    };
    LegendDataComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.uniqueValueSymbolsRef.changes.subscribe(function (previewContainerCollection) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        this.addRenderToClassBreak(previewContainerCollection.toArray());
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    LegendDataComponent.prototype.addRenderToClassBreak = function (previewContainers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.renderPromises.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(this.renderPromises)];
                    case 1:
                        _a.sent();
                        this.renderPromises.length = 0;
                        _a.label = 2;
                    case 2:
                        if (!previewContainers.length) return [3 /*break*/, 4];
                        if (this.node.data && this.node.data.layerData) {
                            if (!this.node.data.layerData.layer) {
                                this.renderPromises.push(this.renderLayerSymbol(this.node.data.layerData, previewContainers));
                            }
                            else if (this.node.data.layerData.layer && this.node.data.layerData.layer.sublayers) {
                                this.renderPromises.push(this.renderLayerSymbol(this.node.data.layerData.layer.sublayers.toArray()[0], previewContainers));
                            }
                        }
                        return [4 /*yield*/, Promise.all(this.renderPromises)];
                    case 3:
                        _a.sent();
                        this.renderPromises.length = 0;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LegendDataComponent.prototype.renderLayerSymbol = function (layer, previewContainers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerKey_1, layerPreviewContainers_1, values;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(layer.renderer && layer.renderer.type === 'unique-value')) return [3 /*break*/, 2];
                        layerKey_1 = getLayerKey(layer);
                        layerPreviewContainers_1 = previewContainers.filter(function (d) { return d.nativeElement.dataset.layerKey === layerKey_1; });
                        if (!layerPreviewContainers_1.length) return [3 /*break*/, 2];
                        values = tslib_1.__spread(layer.renderer.uniqueValueInfos) || [];
                        if (layer.renderer.defaultSymbol) {
                            values.unshift({
                                symbol: layer.renderer.defaultSymbol,
                                value: layer.renderer.defaultLabel
                            });
                        }
                        return [4 /*yield*/, Promise.all(values.map(function (value) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var previewContainer, firstChild, previewHTML;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            previewContainer = layerPreviewContainers_1.find(function (d) { return d.nativeElement.dataset.value === value.value; });
                                            if (!previewContainer) return [3 /*break*/, 2];
                                            firstChild = previewContainer.nativeElement.childNodes[0];
                                            if (firstChild.nodeName === 'DIV') {
                                                // Delete the old symbol before rerendering
                                                firstChild.remove();
                                            }
                                            this.layerService.fixPictureSymbols([value.symbol]);
                                            return [4 /*yield*/, this.SymbolUtils.renderPreviewHTML(value.symbol, { maxSize: 14, scale: true })];
                                        case 1:
                                            previewHTML = _a.sent();
                                            if (!previewContainer.nativeElement.querySelectorAll('.value-symbol').length) {
                                                previewHTML.className = 'value-symbol';
                                                previewContainer.nativeElement.prepend(previewHTML);
                                            }
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LegendDataComponent.prototype.toggleBreakDetails = function (node) {
        node.data.showBreakDetail = !node.data.showBreakDetail;
    };
    LegendDataComponent.prototype.getRoutingDetail = function (node) {
        return node.data.layerData.mapcoreProps.routingDetail;
    };
    return LegendDataComponent;
}(BaseComponent));
export { LegendDataComponent };
